module.exports = {
  googleSearchKey: '017818143311378779828:hkz7dyja5dc',
};
